/* Ensures that videos pause automatically when scrolled out of view */
document.addEventListener("DOMContentLoaded", function () {
  function observeVideo(videoElement) {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) {
            videoElement.contentWindow.postMessage(
              '{"event":"command","func":"pauseVideo","args":""}',
              "*"
            );
          }
        });
      },
      {
        threshold: 0.5,
      }
    );
    observer.observe(videoElement);
  }

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (
          node.nodeType === 1 &&
          node.classList.contains("js-youtube-iframe") &&
          node.tagName === "IFRAME"
        ) {
          observeVideo(node);
        }
      });
    });
  });

  const config = { childList: true, subtree: true };
  observer.observe(document.body, config);
});
